import {
  Box,
  Divider,
  Flex,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { collection, onSnapshot, orderBy } from "firebase/firestore";
import { useEffect } from "react";
import { useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BiSearch } from "react-icons/bi";
import Heading from "../../components/Heading";
import SidebarGroupSkeleton from "../../components/SidebarGroupSkeleton";
import useSmallScreen from "../../components/useSmallScreen";
import { db, getMessages } from "../../service/firebase";
import ChatProfileCard from "./ChatProfileCard";
import ExternalUserChatProfile from "./ExternalUserChatProfile";
import { setRoomID } from "./GroupChat";
import SearchGroup from "./SearchGroup";

function LeftSection({
  changeGroupChat,
  currentGroupChat,
  receiverCurrentChat,
  joinedgroupData,
  incomingLastMessage,
  ////////////
  setShowChatDetails,
  setSelectedChat,
  selectedChat,
  chats,
  userInfo,
  groups,
  setCurrentMobileScreenState,
  ...props
}) {
  const selectedBorderColor = useColorModeValue("#DBE5ED", "#081b2e");
  const selectChatBg = useColorModeValue("#fff", "#010000");
  const inputBorderColor = useColorModeValue("#DBE5ED", "none");

  const [groupSearch, setGroupSearch] = useState("");
  const [userGroupSearchResult, setUserGroupSearchResult] = useState(null);
  const [smallScreen] = useSmallScreen();
  const [allChats, setAllChats] = useState([]);
  const [groupList, setGroupList] = useState(groups);
  const handleGetChats = async (id) => {
    await getMessages(`${id}`, setAllChats);
  };
  const [values, setValues] = useState([]);
  /////////////////////////////

  const [selectedGroupChat, setSelectedGroupChat] = useState(null)
  const [searchText, setSearchText] = useState("")
  const [filteredGroups, setFilteredGroups] = useState([]);

  const changeSelectedGroupChat = (index, groupChat) => {
    setSelectedGroupChat(index);
    changeGroupChat(groupChat);
    setRoomID(groupChat?.id);
    setCurrentMobileScreenState(1);

    //console.log('groupChat', groupChat?.id);
  };
  

  // search group logic, not-used
  useEffect(() => {
    if (!values || !Array.isArray(values) || !groupSearch) {
      setUserGroupSearchResult(null);
      return;
    }
    let getSearchData = values.filter((chatInfo) =>
      chatInfo?.group_chat?.name
        ?.toLowerCase()
        .includes(groupSearch?.toLowerCase())
    );

    if (!getSearchData || getSearchData.length < 1) {
      setUserGroupSearchResult(null);
      return;
    }

    setUserGroupSearchResult(getSearchData);
    //eslint-disable-next-line
  }, [values, groupSearch]);

  //search logic used
  useEffect(() => {
    if (searchText.trim() === "") {
      // If the search text is empty, show all groups
      setFilteredGroups(groups);
      changeSelectedGroupChat(0, groups[0])
    } else {
      // Otherwise, filter groups based on the search text
      const filtered = groups.filter((group) =>
        group?.name.toLowerCase().includes(searchText.toLowerCase())
      );
      setFilteredGroups(filtered);
    }
  }, [searchText, groups]);

  //receiverCurrentChat is activated when sendMsg is triggered
  useEffect(() => {
    // Find the index of the contact in the list.
    const contactIndex = groups.findIndex(
      (group) => group?.id === receiverCurrentChat?.id
    );
    if (contactIndex !== -1) {
      // Remove the contact from the current position.
      const updatedList = [...groups];
      const movedContact = updatedList.splice(contactIndex, 1)[0];

      // Add the contact back to the top of the list.
      updatedList.unshift(movedContact);

      // Update the state with the reordered list.
      setFilteredGroups(updatedList);
    }
  }, [receiverCurrentChat]);

  // ... (previous code)

// ... (previous code)

//if user joined groupChat from groupModal
useEffect(() => {
  if (joinedgroupData) {
    // Find the index of the group in filteredGroups based on joinedgroupData's id
    const matchingIndex = filteredGroups.findIndex(
      (group) => group?.id === joinedgroupData?.id
    );

    if (matchingIndex !== -1) {
      // Create a copy of the filteredGroups array
      const updatedFilteredGroups = [...filteredGroups];
      
      // Extract the matching group
      const matchingGroup = updatedFilteredGroups.splice(matchingIndex, 1)[0];
      //console.log('matchingIndex: ', matchingIndex); //0

      // Insert the matching group at the beginning of the array
      updatedFilteredGroups.unshift(matchingGroup);

      // Update the state with the updated array
      setFilteredGroups(updatedFilteredGroups);
      changeSelectedGroupChat(0, matchingGroup)
    }
  }
}, [joinedgroupData, filteredGroups]);

//console.log('joinedgroupData: ', joinedgroupData);

  //let isTextMatching = searchText ? group?.name?.toLowerCase().includes(searchText.toLowerCase()) : ""

  return (
    <Stack flex="2" {...props}>
      <Stack alignItems={"flex-start"} mb="10px">
        <Flex
          w="100%"
          flexDirection={"row"}
          alignItems="center"
          justifyContent={"space-between"}
        >
          <Heading>Groups</Heading>
          {smallScreen && (
            <AiOutlineInfoCircle
              fontSize={"2em"}
              cursor={"pointer"}
              onClick={() => setCurrentMobileScreenState(2)}
            />
          )}
        </Flex>
        <Divider />

        <ChatProfileCard
          setShowChatDetails={setShowChatDetails}
          userInfo={userInfo}
          chats={chats}
          groups={groups}
          receiverCurrentChat={receiverCurrentChat}
        />
      </Stack>
      <Text color={"#7B8793"} textAlign={"left"} mb="10px !important">
        Active Groups
      </Text>
      <Stack
        h={[window.innerHeight - 280]}
        maxH={[window.innerHeight - 280]}
        overflowY="scroll"
        className="scroll-container"
        px="5px"
      >
        <InputGroup
          mb="10px !important"
          border={`1px solid ${inputBorderColor}`}
          borderRadius={"10px"}
        >
          <InputRightElement
            pointerEvents="none"
            children={
              <BiSearch
                style={{ marginBottom: "10px" }}
                fontSize={".7em"}
                color="#AFBBC6"
              />
            }
          />
          <Input
            size={"xs"}
            placeholder="Search groups"
            type="text"
            borderRadius={"10px"}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </InputGroup>
        <Stack spacing={"10px"}>
          {userGroupSearchResult ? (
            <SearchGroup
              setRoomID={setRoomID}
              handleGetChats={handleGetChats}
              setSelectedChat={setSelectedChat}
              selectedChat={selectedChat}
              selectChatBg={selectChatBg}
              selectedBorderColor={selectedBorderColor}
              values={values}
              userInfo={userInfo}
              searchResult={userGroupSearchResult}
            />
          ) : filteredGroups?.length > 0 ? (
            filteredGroups?.map((group, index) => {
                return (
                  <Box
                    key={group?.id}
                    borderRadius={"7px"}
                    p="7px"
                    cursor={"pointer"}
                    // onClick={() => {
                    //   setSelectedChat(group?.group_chat?.id);
                    //   setRoomID(group?.group_chat_id);
                    //   handleGetChats(group?.group_chat?.id);

                    //   setCurrentMobileScreenState(1);
                    // }}
                    onClick={() => {
                      changeSelectedGroupChat(index, group)
                      /////////////////////
                      
                    }}
                    bg={
                      index === 0
                        ? selectChatBg
                        : null
                    }
                    border={
                      index === selectedGroupChat
                        ? `1px solid ${selectedBorderColor}`
                        : null
                    }
                  >
                    <ExternalUserChatProfile
                      id={group?.group_chat?.id}
                      group={group}
                      userInfo={userInfo}
                      incomingLastMessage={incomingLastMessage}
                    />
                  </Box>
                );
              })
          ) : (
            <SidebarGroupSkeleton />
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}

export default LeftSection;
